module.exports = __webpack_public_path__ + "img/ae-1.fa5159c.png";